module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/trust-and-transparecy-300x300.947a0bd2.jpg";